import * as constants from '../constants';

export const requestSurvey = (id) => ({type: constants.SURVEY_REQUESTED, payload: {id}});
export const requestTrackedSurvey = (code) => ({type: constants.SURVEY_TRACKED_REQUESTED, payload: {code}});
export const surveyFailure = (id, error) => ({type: constants.SURVEY_FAILURE, payload: {id, error}});
export const surveySuccess = (id, item) => ({type: constants.SURVEY_SUCCESS, payload: {id, item}});

export const requestCreateSurveyInstance = (id, extra) => ({type: constants.SURVEY_CREATE_INSTANCE_REQUESTED, payload: {id, extra}});
export const requestCreateTrackedSurveyInstance = (code, extra) => ({type: constants.SURVEY_TRACKED_CREATE_INSTANCE_REQUESTED, payload: {code, extra}});
export const createSurveyInstanceFailure = (error) => ({type: constants.SURVEY_CREATE_INSTANCE_FAILURE, payload: {error}});
export const createSurveyInstanceSuccess = (surveyId, instanceId) => ({type: constants.SURVEY_CREATE_INSTANCE_SUCCESS, payload: {surveyId, instanceId}});
